module.exports = __webpack_public_path__ + "img/home-07-cosmo-01-popup-main.54d2b8b3.jpg";